import { Stack, Typography, Button, Box } from "@mui/material";
import warning_icon from "../../../assets/images/Icons/icAlert.svg";
import { CustomeDialog } from "../../../shared";

export const DeleteFutureCostDialog = ({ rows, open, onDelete, onCancel }) => {
  return (
    <CustomeDialog
      title={
        <Stack direction="row" gap="10px" alignItems="center" p="24px" pb="8px">
          <Box
            sx={{
              width: "30px",
              height: "30px",
              borderRadius: "35px",
              bgcolor: "#F044381F",
            }}
          >
            <img
              src={warning_icon}
              style={{ padding: "6px" }}
              alt="delete-future-cost"
            />
          </Box>
          <Typography fontWeight={500} variant="body1" fontSize="20px">
            Delete?
          </Typography>
        </Stack>
      }
      open={open}
      divider={false}
      content="Are you sure you want to delete the scheduled cost change for the selected ingredients?"
      footer={{
        display: true,
        cancelButton: "Close",
        confirmButton: (
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={() => {
              onCancel();
              onDelete(rows);
            }}
          >
            Delete
          </Button>
        ),
        onConfirm: true,
        onCancel: onCancel,
      }}
      sx={{
        pt: "16px",
        px: "24px",
        pb: "8px",
        width: { md: "500px", sm: "400px", xs: "90%" },
      }}
    />
  );
};
